import { ListTimelineEntriesQuery } from '../../../types/__generated__';
import useFullPageQuery from '../useFullPageQuery';
import { usePageOwner } from '../usePageOwner';
import query from './queries/listTimelineEntries.gql';
import { useMeasurementSystem } from './useMeasurementSystem';

export function useListTimelineEntries() {
  const measurementSystem = useMeasurementSystem();
  const { isPageOwner } = usePageOwner();

  return useFullPageQuery<ListTimelineEntriesQuery>(query, {
    variables: { measurementSystem, first: 3 },
    context: {
      credentials: isPageOwner ? 'include' : 'omit',
    },
  });
}
